module.exports = __webpack_public_path__ + "img/_K8A7795.1f5d4e98.jpeg";